import { YStack } from '@mythical/ui'
import { BenefitsBanner as BenefitsBannerType } from 'app/blocks/landing/benefits-banner'
import BenefitLinks from 'app/components/primitive/BenefitLinks'
import React from 'react'

interface BenefitsBannerBlockProps {
  block: BenefitsBannerType
}

export const BenefitsBannerBlock: React.FC<BenefitsBannerBlockProps> = ({
  block,
}) => {
  if (!block.benefits || block.benefits.length === 0) return null

  return (
    <YStack gap="$4">
      <BenefitLinks {...block} />
    </YStack>
  )
}
